import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { get } from 'lodash';
import { withTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import Button from '../../../shared/components/Button';
import axios from '../../../utils/axiosConfig';
import userSession from '../../../utils/userSession';
import './WelcomeMsg.scss';

class WelcomeMsg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWelcomeMsg: false,
      isMounted: true
    };
  }

  componentDidMount() {
    this.checkWelcomeMsg();
  }

  componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  }

  checkWelcomeMsg() {
    const handleLogout = this.props.handleLogout;
    axios.get('/api/v1/influencers/influencers/get_user_welcome_msg')
      .then(({ data }) => {
        if (this.state.isMounted) {
          this.setState({ showWelcomeMsg: data.show_user_welcome_msg });
        }
      }).catch((error) => {
        console.log(error);

        if ([401].includes(get(error.response, 'status'))) {
          handleLogout();
        }
      });
  }

  //remove after testing
  expireWelcomeMsg() {
    axios.get('/api/v1/influencers/influencers/expire_user_welcome_msg')
      .then(({ data }) => {
        if (this.state.isMounted) {
          this.setState({ showWelcomeMsg: data.show_user_welcome_msg });
        }
      }).catch(function (error) {
        console.log(error);
      });
  }


  render() {
    const { showWelcomeMsg } = this.state;
    const admin = userSession('admin');
    const { t } = this.props;

    if (showWelcomeMsg) {
      return (
        <div className='mb-6' id='home-msg'>
          <div className="container">
            <Row>
              <Col lg='12'>
                <div className='home-welcome-title mb-5'>
                  {t('influencers.pages.home.welcome_title', { name: userSession('first_name') })}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg='8'>
                <h6 className='mb-3'>
                  {t('influencers.pages.home.welcome_sub_title')}
                </h6>

                <div className='text-medium-1 mb-5'>
                  {t('influencers.pages.home.welcome_description')}
                </div>

                <div className='mt-5 mb-5'>
                  <Button variant="primary" onClick={() => this.setState({ showWelcomeMsg: false })}>
                    {t('influencers.pages.home.hide_intro')}
                  </Button>
                </div>
              </Col>
              <Col lg='3'>
                <h6 className='mb-3'>
                  {t('influencers.pages.home.helpful_links')}
                </h6>
                <div className='mb-4'>
                  <Link key='header-msg-learn' to='/learning-center' >{t('influencers.pages.home.learn_more')}</Link>
                  <br/>
                  <Link key='header-msg-profile' to='/profile' >{t('influencers.pages.home.see_profile')}</Link>
                  <br/>
                  <Link key='header-msg-analytics' to='/analytics' >{t('influencers.pages.home.see_analytics')}</Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      );
    }

    return (
      <div id="home-msg-show" onClick={() => this.expireWelcomeMsg()}>
        <ReactTooltip offset={{ bottom: 20 }} />
        { admin ?
          <i className="fal fa-arrow-alt-circle-down" data-tip={t('influencers.pages.home.reset_welcome_msg')} ></i>
          :
          <div></div>
        }
      </div>
    );
  }
}

export default withTranslation()(WelcomeMsg);
